import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function initSection() {
  const sections = document.querySelectorAll(".section")
  const translationY = 440;

  sections.forEach((section, index) => {
    const nextSection = sections[index + 1]
    const isLastSection = !nextSection
    const shouldApplyEffect =
      !section.classList.contains("no-effect") &&
      (isLastSection ||
        (nextSection && nextSection.classList.contains("rounded-top")))

    if (!shouldApplyEffect || section.classList.contains("section__hero"))
      return

    const content = section.querySelector("div:first-child")

    // Store the original padding-bottom of the content
    const originalPaddingBottom = window.getComputedStyle(content).paddingBottom

    // Add padding-bottom to the current section
    const updatePadding = () => {
        if (window.innerWidth <= 1024) {
      content.style.paddingBottom = originalPaddingBottom
      } else {
        content.style.paddingBottom = "320px"
      }
    }

    // Initial padding update
    updatePadding()

    // Update padding on resize
    window.addEventListener("resize", updatePadding)

    // Encapsulate the GSAP animation in a function
    function triggerGsapAnimation() {
      gsap.to(content, {
        y: translationY,
        ease: "none",
        scrollTrigger: {
          trigger: section,
          start: "center center",
          end: "bottom top",
          scrub: true,
          onEnter: () => {
            section.style.zIndex = 1
            if (nextSection) nextSection.style.zIndex = 2
          },
          onLeaveBack: () => {
            section.style.zIndex = 2
            if (nextSection) nextSection.style.zIndex = 1
          },
        },
      })
    }

    // Call the function on page load
    triggerGsapAnimation()
  })

  // Observe the section a do the hack of trigger resize which will fix the translateY issue
  const allSections = document.querySelectorAll(".section")
  if (allSections.length > 0) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            window.dispatchEvent(new Event("resize"))
          }
        })
      },
      { threshold: 0.1 }
    ) // Adjust threshold as needed

    allSections.forEach((section) => {
      observer.observe(section)
    })
  }
}
